<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">


    <div *ngIf="!isList">

            <div class="card card-custom bg-light-warning card-stretch gutter-b h-100">

                <!-- HEADER -->
                <div class="card-header border-0 bg-warning">
                    <div class="col">
                        <span class="text-light font-weight-normal font-size-h6">
                            {{artikel.name}}
                        </span>
                    </div>
                </div>
    
                <!-- BODY -->
                <div class="card-body p-2 position-relative overflow-hidden">
                    <div class="col mt-2 artikelcard">
                        <img src="data:image/jpeg;base64,{{imgFile}}" />
                    </div>
                </div>
    
                <!-- FOOTER -->
                <div class="card-footer border-0 bg-warning">
                    <div class="title mt-4">
                        {{artikel.name}}
                    </div>
                    <div class="price">
                        {{artikel.vkPreis | currency: 'EUR':'symbol'}}
                    </div>
                </div>
    
            </div>
    



        <!-- <img src="data:image/jpeg;base64,{{imgFile}}" />
        <button mat-icon-button class="btn btn1" aria-label="Card-Basket" matTooltip="In den Warenkorb">
            <i class="flaticon2-shopping-cart-1 icon-lg"></i>
        </button>
        <button mat-icon-button (click)="onOpenArtikelQuickView()" class="btn btn2" aria-label="Card-Details" matTooltip="Schnellansicht">
            <i class="flaticon2-search-1 icon-lg"></i>
        </button>
        <div class="title mt-4">
            {{artikel.name}}
        </div>
        <div class="price">
            {{artikel.vkPreis | currency: 'EUR':'symbol'}}
        </div> -->

    </div>

    
    <!-- <div *ngIf="!isList">
        <div class="artikelcard" align="center">
            <div class="p-4">
                <img src="data:image/jpeg;base64,{{imgFile}}" />
            </div>
            <button mat-icon-button class="btn btn1" aria-label="Card-Basket" matTooltip="In den Warenkorb">
                <i class="flaticon2-shopping-cart-1 icon-lg"></i>
            </button>
            <button mat-icon-button (click)="onOpenArtikelQuickView()" class="btn btn2" aria-label="Card-Details" matTooltip="Schnellansicht">
                <i class="flaticon2-search-1 icon-lg"></i>
            </button>
            <div class="title mt-4">
                {{artikel.name}}
            </div>
            <div class="price">
                {{artikel.vkPreis | currency: 'EUR':'symbol'}}
            </div>
    
        </div>
    </div> -->

    <div *ngIf="isList">
        <div class="row">
            <div class="col-3">
                <div class="artikelcard theme-customer" align="center">
                    <img src="data:image/jpeg;base64,{{imgFile}}"/>
                    <button mat-icon-button class="btn btn1" aria-label="Card-Basket" matTooltip="In den Warenkorb">
                        <i class="flaticon2-shopping-cart-1 icon-lg"></i>
                    </button>
                    <button mat-icon-button (click)="onOpenArtikelQuickView()" class="btn btn2" aria-label="Card-Details" matTooltip="Details anzeigen">
                        <i class="flaticon2-search-1 icon-lg"></i>
                    </button>
                </div>
            </div>
            <div class="col-9">
                <div class="title mt-4">
                    {{artikel.name}}
                </div>
                <div class="text">
                    {{artikel.text}}
                </div>
                <div class="price">
                    {{artikel.vkPreis | currency: 'EUR'}}
                </div>
            </div>
        </div>
    </div>
</div>